import { render, staticRenderFns } from "./ProductCombinations.vue?vue&type=template&id=47b59031&scoped=true&"
import script from "./ProductCombinations.vue?vue&type=script&lang=js&"
export * from "./ProductCombinations.vue?vue&type=script&lang=js&"
import style0 from "./ProductCombinations.vue?vue&type=style&index=0&id=47b59031&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b59031",
  null
  
)

export default component.exports